module.exports = __webpack_public_path__ + "img/cloth_g3_hat-01.128e7d62.svg";